import React from 'react';
import useTranslations from '../../../hooks/useTranslations';
import Colors from '../../Colors';
import _GeneralDialog from '../../GeneralDialog';
import FieldCalculatorEngine from '../../field-combiner/engine/FieldCalculatorEngine';
import styled from 'styled-components/macro';

const GeneralDialog = styled(_GeneralDialog)`
  [class*='MuiDialogContent-root'] {
    overflow-x: hidden;
    padding: 0;
  }
`;

const ScoreSettingsPanelView = props => {
  const t = useTranslations();
  return (
    <GeneralDialog
      titleBlockProps={{
        $customCSS: `background: ${Colors.PRIMARY}; h2 {color:#fff;}`
      }}
      customCSS={`svg[id='close-dialog'] {color: #fff;}`}
      buttons={[
        {
          text: 'forms.field_type.score_save',
          onClick: () => {
            props.clickedSave();
          },
          disabled: props.saveDisabled
        }
      ]}
      disableBackdropClick
      fullWidth
      handleClose={() => props.setShowScoreDialog(false)}
      handleConfirm={() => props.clickedSave}
      maxWidth="lg"
      open={props.showScoreDialog}
      title="forms.field_type.score"
    >
      <FieldCalculatorEngine
        fields={props.fieldDropDownOptions}
        onChangedFormula={props.onChangedFormula}
        initialFormulaArray={props.initialFormulaArray}
        validationError={props.validationError}
      />
    </GeneralDialog>
  );
};

export default ScoreSettingsPanelView;
